import { useLayoutEffect, useState } from 'react'

export const makeTokenHeaderConfig = (token: string) => ({
    headers: { Authorization: 'Bearer ' + token },
})

export const makeTokenFileConfig = (
    token: string,
    fileName: string,
    onUploadProgress: (progressEvent: ProgressEvent) => void,
) => ({
    headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'multipart/form-data',
    },
    onUploadProgress,
})

export const useTokenHeaderConfig = (): [string] => {
    const [tokenInfo, setTokenInfo] = useState<string>('')

    useLayoutEffect(() => {
        const token = localStorage.getItem('token')
        setTokenInfo(token || '')
    })

    return [tokenInfo]
}
